import { BASE_CND } from "../constants/urls.js";
const tooltipLogoUrl = (logo)=>new URL(`design-assets/pcln-bot/logos/${logo}`, BASE_CND);
export { tooltipLogoUrl };
